import { KeyboardEvent, memo, ReactElement } from 'react';
import { Colors } from '~/themes/colors';
import { Box, Text } from '../index';
import { TOptionValue } from './Types';

interface IPillOptionProps<T> extends TOptionValue<T> {
  isChecked?: boolean;
  onClick: (value: T, isChecked: boolean) => void;
}

const Component = <T extends string | number = string>({
  isChecked = false,
  label,
  value,
  onClick,
}: IPillOptionProps<T>) => (
  <Box
    paddingBlock={8}
    paddingInline={20}
    borderRadius={24}
    borderStyle="solid"
    borderWidth={1.5}
    backgroundColor={isChecked ? Colors.primary_50 : Colors.white}
    borderColor={isChecked ? Colors.secondary_500 : Colors.neutral_100}
    cursor="pointer"
    data-testid={`multi-select-group.pill.${label}`}
    role="button"
    tabIndex={0}
    alignItems="center"
    justifyContent="center"
    onClick={() => onClick(value, !isChecked)}
    onKeyDown={(e: KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick(value, !isChecked);
      }
    }}
  >
    <Text>{label}</Text>
  </Box>
);

export const PillOption = memo(Component) as <T extends string | number = string>(
  props: IPillOptionProps<T>,
) => ReactElement;
